import { t } from "@/i18n-js/instance";

export const CHAT_SORT_VALUES = {
  LATEST: "latest",
  OLDEST: "oldest",
} as const;

export const CHAT_TYPES = {
  ALL: "all",
  UNREAD: "admin_unread",
  AI_PAUSED: "ai_paused",
} as const;

export const ALL_AGENTS_INITIAL_STATE = {
  get name() {
    return t("community_inbox.filters.all_agents");
  },
  id: 0,
} as const;
